(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resource-list-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.resource-list__carousel[autoplay]').forEach((component) => {
      const forceResume = () => {
        component.paused = false;
        component.play();
      };
      component.addEventListener('pointerup', forceResume);
      component.addEventListener('pointercancel', forceResume);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
